import Typography from '~/shared/components/Typography';
import { type TimeParts } from '~/shared/components/DateRangePopup/helpers';
import AmPmToggle from '~/shared/components/AmPmToggle';
import TimeNumberInput from '~/shared/components/TimeNumberInput';

interface TimePartsRowProps {
  label: string;
  value: TimeParts;
  onChange: (next: TimeParts) => void;
}

export default function TimePartsRow({ label, value, onChange }: TimePartsRowProps) {
  const setPart = (partial: Partial<TimeParts>) => onChange({ ...value, ...partial });

  return (
    <div className="flex flex-col gap-2">
      <Typography variant="p3" fontWeight={400}>
        {label}
      </Typography>
      <div className="flex gap-2">
        <div className="flex h-fit gap-1">
          <TimeNumberInput
            min={1}
            max={12}
            placeholder="HH"
            value={value.hours}
            onChange={(hours) => setPart({ hours })}
          />
          <span className="mt-1">:</span>
          <TimeNumberInput
            min={0}
            max={59}
            placeholder="mm"
            value={value.minutes}
            onChange={(minutes) => setPart({ minutes })}
          />
        </div>
        <AmPmToggle
          value={value.isPm}
          onChange={(isPm) => setPart({ isPm })}
        />
      </div>
    </div>
  );
}
